import React, { type PropsWithChildren, useEffect, useState } from 'react';

type Props = PropsWithChildren & {};

const Hero: React.FC<Props> = ({ children }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 0;
      setIsScrolled(scrolled);
      if (scrolled && !hasScrolled) {
        setHasScrolled(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [hasScrolled]);

  const bottomSpacing = isScrolled ? 80 : 0;
  const overlayOpacity = isScrolled ? 0 : 0.5;
  const arrowOpacity = hasScrolled ? 0 : 1;

  return (
    <div className="relative h-screen w-screen max-w-full bg-white">
      {/* Background Image - Fixed */}
      <div
        className="absolute z-0 h-full w-full"
        style={{
          backgroundImage:
            'url(https://www.volvopenta.com/-/media/volvopenta/about-us/sustainability/sustainable-solutions-2324x1200.jpg?mh=1307&mw=2536&v=q4BbPw&c=1&cw=2324&ch=1307&jq=80&hash=222312C06D721DF8166C373D57F82BD2)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      />

      {/* Black Overlay */}
      <div
        className="absolute inset-0 z-10 bg-black"
        style={{
          opacity: overlayOpacity,
          transition: 'opacity 0.3s ease-out',
        }}
      />

      {/* Left White Bar */}
      <div
        className="absolute top-0 left-0 z-10 h-full bg-white"
        style={{
          width: 'max(calc(50% - 720px), 24px)',
          transformOrigin: '0% 0% 0px',
          transform: `scale(${isScrolled ? 0.665 : 0}, 1)`,
          transition: 'transform 0.6s ease-out',
        }}
      />

      {/* Right White Bar */}
      <div
        className="absolute top-0 right-0 z-10 h-full bg-white"
        style={{
          width: 'max(calc(50% - 720px), 24px)',
          transformOrigin: '100% 0% 0px',
          transform: `scale(${isScrolled ? 0.665 : 0}, 1)`,
          transition: 'transform 0.6s ease-out',
        }}
      />

      {/* Bottom White Bar */}
      <div
        className="absolute bottom-0 left-0 z-10 w-full bg-white"
        style={{
          height: `${bottomSpacing}px`,
          transition: 'height 0.6s ease-out',
        }}
      />

      <div
        className={`hero-content-stagger absolute inset-0 z-30 flex flex-col items-center justify-center ${isScrolled ? 'hero-content-hidden' : ''}`}
      >
        {children}
      </div>

      {/* Animated Arrow */}
      <div
        className="absolute bottom-6 left-1/2 z-30 -translate-x-1/2"
        style={{
          opacity: arrowOpacity,
          transition: 'opacity 0.2s ease-out',
          pointerEvents: hasScrolled ? 'none' : 'auto',
        }}
      >
        <div className="relative overflow-hidden" style={{ width: '18px', height: '114px' }}>
          {/* Arrow SVG with 50% white background */}
          <svg
            width="18"
            height="114"
            viewBox="0 0 18 114"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="absolute inset-0"
          >
            <path
              d="M9 0V106M9 106L1 98M9 106L17 98"
              stroke="rgba(255, 255, 255, 0.5)"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          {/* Animated 100% white overlay */}
          <svg
            width="18"
            height="114"
            viewBox="0 0 18 114"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="absolute inset-0"
            style={{
              maskImage:
                'linear-gradient(to bottom, transparent 0%, transparent 30%, white 45%, white 55%, transparent 70%, transparent 100%)',
              WebkitMaskImage:
                'linear-gradient(to bottom, transparent 0%, transparent 30%, white 45%, white 55%, transparent 70%, transparent 100%)',
              maskSize: '100% 114px',
              WebkitMaskSize: '100% 114px',
              maskPosition: '0 0',
              WebkitMaskPosition: '0 0',
              animation: 'arrowSlide 2s linear infinite',
            }}
          >
            <path
              d="M9 0V106M9 106L1 98M9 106L17 98"
              stroke="rgba(255, 255, 255, 1)"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};
export default Hero;
